import gql from 'graphql-tag';

// eslint-disable-next-line import/prefer-default-export
export const UPDATE_OFFER_NOTIFICATION = gql`
  mutation readNotification($offerId: String!, $artistId: String!) {
    readNotification(offerId: $offerId, artistId: $artistId) {
        message
    }
  }
`;
